import React, { createContext, useContext, useState, ReactNode } from "react";

// Helper function to get academic year from a date
export const getAcademicYear = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // JavaScript months are 0-indexed

  // Academic year starts in September (month 9)
  if (month >= 9) {
    return `${year}/${year + 1}`;
  } else {
    return `${year - 1}/${year}`;
  }
};

export const getCurrentAcademicYear = (): string => {
  return getAcademicYear(new Date());
};

interface AcademicYearContextType {
  selectedAcademicYear: string;
  setSelectedAcademicYear: (year: string) => void;
  getAcademicYear: (date: Date) => string;
  getCurrentAcademicYear: () => string;
}

const AcademicYearContext = createContext<AcademicYearContextType | undefined>(
  undefined,
);

export const useAcademicYear = () => {
  const context = useContext(AcademicYearContext);
  if (!context) {
    throw new Error(
      "useAcademicYear must be used within an AcademicYearProvider",
    );
  }
  return context;
};

interface AcademicYearProviderProps {
  children: ReactNode;
}

export const AcademicYearProvider: React.FC<AcademicYearProviderProps> = ({
  children,
}) => {
  const [selectedAcademicYear, setSelectedAcademicYear] =
    useState<string>("current");

  return (
    <AcademicYearContext.Provider
      value={{
        selectedAcademicYear,
        setSelectedAcademicYear,
        getAcademicYear,
        getCurrentAcademicYear,
      }}
    >
      {children}
    </AcademicYearContext.Provider>
  );
};
